import React from "react";
import "./InfoContainer.css";

const InfoContainer = ({
  title = "CONNECTING THE WORLD",
}) => {
  return (
    <div className="info-section">
      <div className="info-header">
        <h1 className="info-title">{title}</h1>
      </div>

      <div className="info-content">
        <p>
          Dohrnii Exim Private Limited is a diversified Indian company engaged in
          manufacturing, sourcing, and global trade of high-quality chemical raw
          materials, petrochemicals, active pharmaceutical ingredients, food
          ingredients, spices, and agricultural commodities. Headquartered in
          Navi Mumbai, India, we have established a strong international presence
          across Asia, the Middle East, and Africa, connecting manufacturers and
          markets through reliability and performance.
        </p>

        <p>
          With deep industry expertise and strong supplier networks, we
          specialize in delivering industrial-grade materials, specialty
          formulations, and customized solutions. Our manufacturing and partner
          facilities follow international quality and safety standards, ensuring
          consistency, compliance, and efficiency across every shipment.
        </p>

        <hr />

        <h2>Our Expertise</h2>
        <ul>
          <li>
            Manufacturing &amp; Sourcing of Active &amp; Inactive Pharmaceutical
            Ingredients (APIs &amp; Excipients)
          </li>
          <li>
            Production and Supply of Petrochemicals and Polymers including
            Polypropylene (PP), Polyethylene (PE), and related raw materials
          </li>
          <li>
            Industrial and Specialty Chemicals for pharmaceutical, food
            processing, and cosmetic industries
          </li>
          <li>Export of Indian Spices, Pulses, Rice, and Agro Commodities</li>
          <li>Customized Blending, Repacking, and Private Label Solutions</li>
        </ul>

        <hr />

        <h2>Our Commitment</h2>
        <p>
          At Dohrnii Exim, we believe that strong partnerships are built on
          trust, transparency, and quality. Every transaction reflects our
          commitment to sustainability, ethical sourcing, and customer
          satisfaction. We aim to be a strategic global partner — bridging the
          gap between manufacturers and end-users while supporting industrial
          growth and trade development across borders.
        </p>

        <hr />

        <h2>Our Reach</h2>
        <p>We proudly serve clients across :</p>
        <ul>
          <li>Japan, China, South Korea, Malaysia, and Indonesia</li>
          <li>
            UAE, Saudi Arabia, Egypt, South Africa, Kenya, and other African
            regions
          </li>
          <li>Expanding steadily into Europe and North America</li>
        </ul>
      </div>

    </div>
  );
};

export default InfoContainer;
